export default __webpack_public_path__ + "static/media/447.8489a1fd.png";